module.exports = __webpack_public_path__ + "img/5.34f6220b.jpg";